import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import verifyIsLoginActive from 'util/verifyIsLoginActive'

export const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        // Antes checava apenas se o token EXISTIA no localStorage. Um token
        // expirado (presente, porem vencido) passava por aqui e a tela quebrava
        // ao acessar dados do usuario que ja nao existem mais. Agora validamos
        // se a sessao esta realmente ATIVA (mesma regra usada no resto do app).
        verifyIsLoginActive() ? (
          <Component {...props} />
        ) : (
          <Redirect to="/" />
        )
      }
    />
  )
}
